import { APPEND_COUPONS, APPEND_GIFT_COUPONS, SET_COUPON, SET_COUPON_DISABLED_FOR_KASSE, SET_COUPON_ERROR_IS_EXIST, SET_COUPON_TYPE, SET_COUPONS, SET_COUPONS_LENGTH, SET_FLYER_COUPON, SET_FLYER_COUPON_ERROR_IS_EXIST, SET_FLYER_COUPON_IS_INVALID, SET_FLYER_COUPON_IS_USED, SET_FLYER_COUPON_LOADING, SET_FLYER_COUPONS, SET_GIFT_COUPON, SET_GIFT_COUPON_IS_CANCELED, SET_GIFT_COUPON_IS_INVALID, SET_GIFT_COUPON_IS_NOT_EXIST, SET_GIFT_COUPON_IS_USED, SET_GIFT_COUPONS, SET_GIFT_COUPONS_LENGTH, SET_VALIDATED_FLYER_COUPON } from '../../actionTypes/coupon'

export const setCoupon = value => ({ type: SET_COUPON, value })

export const setCoupons = value => ({ type: SET_COUPONS, value })

export const appendCoupons = value => ({ type: APPEND_COUPONS, value })

export const setCouponsLength = value => ({ type: SET_COUPONS_LENGTH, value })

export const setCouponErrorIsExist = value => ({ type: SET_COUPON_ERROR_IS_EXIST, value })

export const setCouponDisabledForKasse = value => ({ type: SET_COUPON_DISABLED_FOR_KASSE, value })

export const setGiftCoupons = value => ({ type: SET_GIFT_COUPONS, value })

export const setGiftCouponsLength = value => ({ type: SET_GIFT_COUPONS_LENGTH, value })

export const appendGiftCoupons = value => ({ type: APPEND_GIFT_COUPONS, value })

export const setGiftCouponIsInvalid = value => ({ type: SET_GIFT_COUPON_IS_INVALID, value })

export const setGiftCouponIsUsed = value => ({ type: SET_GIFT_COUPON_IS_USED, value })

export const setGiftCouponIsNotExist = value => ({ type: SET_GIFT_COUPON_IS_NOT_EXIST, value })

export const setGiftCouponIsCanceled = value => ({ type: SET_GIFT_COUPON_IS_CANCELED, value })

export const setGiftCoupon = value => ({ type: SET_GIFT_COUPON, value })

export const setFlyerCoupon = value => ({ type: SET_FLYER_COUPON, value })

export const setFlyerCoupons = value => ({ type: SET_FLYER_COUPONS, value })

export const setFlyerCouponErrorIsExist = value => ({ type: SET_FLYER_COUPON_ERROR_IS_EXIST, value })

export const setFlyerCouponIsInvalid = value => ({ type: SET_FLYER_COUPON_IS_INVALID, value })

export const setValidatedFlyerCoupon = value => ({ type: SET_VALIDATED_FLYER_COUPON, value })

export const setFlyerCouponLoading = value => ({ type: SET_FLYER_COUPON_LOADING, value })

export const setFlyerCouponIsUsed = value => ({ type: SET_FLYER_COUPON_IS_USED, value })

export const setCouponType = value => ({ type: SET_COUPON_TYPE, value })
